import React, { useEffect, useState } from "react";
import { ImageBackground, StyleSheet } from "react-native";
import { useSelector } from "react-redux";
import { useIsFocused } from "@react-navigation/native";
import BackgroundImage from "@assets/images/header/header_background.png";
import LargeWidget from "./LargeWidget";
import SmallWidget from "./SmallWidget";
import ExtraLargeWidget from "./ExtraLargeWidget";
import Banner from "./Banner";
import RowWidget from "./RowWidget";

const HomePageWidget = () => {
  const { widgets: liveWidgets = {} } = useSelector(
    (state) => state.homePageWidget,
  );
  const isFocused = useIsFocused();
  // Screens navigated to from Home (e.g. DbManagement) dispatch
  // fetchHomePageWidget() on their own focus to refresh this same widgets
  // slice for when the user returns. React Navigation keeps Home mounted
  // (not unmounted) while backgrounded, so without this guard that dispatch
  // forces Home's still-mounted widget list to remount its Fabric views at
  // the exact moment the navigation transition is also mounting the new
  // screen — a genuine cross-screen race, not a timing issue local to Home.
  // Only adopt the live redux value while Home is actually focused, so a
  // background update can't touch this tree until the transition is over.
  const [widgets, setWidgets] = useState(liveWidgets);
  useEffect(() => {
    if (isFocused) setWidgets(liveWidgets);
  }, [isFocused, liveWidgets]);

  return (
    <ImageBackground
      source={BackgroundImage}
      resizeMode="cover"
      style={styles.background}
      imageStyle={styles.backgroundImage}
    >
      {Object.keys(widgets).map((widgetKey) => {
        const item = widgets[widgetKey];
        if (!item) return null;
        const key = item.id ?? widgetKey;
        switch (item.widget_type) {
          case "BANNER":
            return <Banner key={key} item={item} />;
          case "ROW":
            return <RowWidget key={key} item={item} />;
          case "EXTRA_LARGE_BOX":
            return <ExtraLargeWidget key={key} item={item} />;
          case "LARGE_BOX":
            return <LargeWidget key={key} item={item} />;
          case "SMALL_BOX":
          default:
            return <SmallWidget key={key} item={item} />;
        }
      })}
    </ImageBackground>
  );
};

export default HomePageWidget;

const styles = StyleSheet.create({
  backgroundImage: {
    height: "50%",
  },
  background: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    paddingHorizontal: 10,
  },
});
